"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContractConfirmed = exports.updateContractConfirmed = exports.searchParamContractId = void 0;
const react_1 = require("react");
const crypto_1 = require("utils/crypto");
const storage_1 = require("./storage");
exports.searchParamContractId = new URLSearchParams(window.location.search).get("contractId") || undefined;
const updateContractConfirmed = ({ issuerId, email, }, value) => {
    const storageKey = `privacyPoricyConfirmed:${issuerId}:${email}`;
    if (value) {
        localStorage.setItem(storageKey, JSON.stringify(value));
    }
    else {
        localStorage.removeItem(storageKey);
    }
};
exports.updateContractConfirmed = updateContractConfirmed;
const useContractConfirmed = ({ contractTitle, contractContent, issuerId, email, }, syncMode) => {
    const [storedContractId, setStoredContractId] = (() => {
        const storageKey = `privacyPoricyConfirmed:${issuerId}:${email}`;
        const [storedContractId, setStoredContractId] = (0, storage_1.useLocalStorage)(storageKey, exports.searchParamContractId || null);
        if (email && syncMode === "sync") {
            (0, react_1.useState)(null);
            return [storedContractId, setStoredContractId];
        }
        else if (email && syncMode === "readOnly") {
            return (0, react_1.useState)(storedContractId);
        }
        else {
            return (0, react_1.useState)(null);
        }
    })();
    const confirmedContractId = (0, react_1.useMemo)(() => {
        return (0, crypto_1.getHashSHA256)(`${issuerId}:${contractTitle}:${contractContent}`);
    }, [issuerId, contractTitle, contractContent]);
    const setContractConfirmed = (0, react_1.useCallback)((contractConfirmed) => {
        const newValue = contractConfirmed ? confirmedContractId : null;
        setStoredContractId(newValue);
        return newValue || undefined;
    }, [confirmedContractId]);
    const contractConfirmed = (0, react_1.useMemo)(() => {
        return storedContractId === confirmedContractId;
    }, [storedContractId, confirmedContractId]);
    return {
        contractConfirmed,
        setContractConfirmed,
        confirmedContractId: contractConfirmed ? confirmedContractId : undefined,
    };
};
exports.useContractConfirmed = useContractConfirmed;
